module.exports = __webpack_public_path__ + "static/media/file-icon.93459ddf.svg";